import Requests from "../../../services/requests";
import React, { useEffect, useState } from "react";
import "./styles.css";
import {
    BsFillClipboardCheckFill,
    BsFillArrowRightSquareFill,
    BsFillArrowLeftSquareFill,
} from "react-icons/bs";
import MenuLateral from "../../../components/menu-lateral";
import MenuHeader from "../../../components/menu-header";
import SearchInputNR from "../../../components/filter-search-nr-ident";
import SearchByDate from "../../../components/filter-search-data";

const formatDate = (date) => {
    const dataBanco = new Date(date);
    const dataFormatada = dataBanco.toLocaleDateString();
    return dataFormatada;
};

export function AparelhosAutonomos({ token }) {
    let config = { headers: { "x-access-token": token } };

    const [originalData, setOriginalData] = useState([]);
    const [newData, setNewData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [pageNumber, setPageNumber] = useState(1);

    useEffect(() => {
        async function fetchData() {
            try {
                await Requests.getRealizadosAparelhosAutonomos(config).then(
                    (res) => {
                        setOriginalData(res);
                        setNewData(res);
                    }
                );
                await Requests.putAllDtFinalAparelhos(config).then((res) => {
                    return res;
                });
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, []);

    if (isLoading) {
        return (
            <div className="loading">
                <p>Loading...</p>
            </div>
        );
    }

    const handleCardClick = (check) => {
        window.location.href = `/realizados/aparelhos/autonomos/${check.id}`;
    };

    const handleSearchNR = (searchValue) => {
        // Filtrar os resultados com base no número de identificação
        const filteredData = originalData.filter((check) => {
            const searchLower = searchValue.toLowerCase();
            const nrLower = check.aparelho.nr_identificacao.toLowerCase();
            return nrLower.includes(searchLower);
        });

        setNewData(filteredData);
        setPageNumber(1); // Redefinir o número da página para 1 ao filtrar os dados
    };

    const handleSearchDate = (searchValue) => {
        // Filtrar os resultados com base na data
        const filteredData = originalData.filter((check) => {
            if (!check?.data_inspecao) return false;

            const checkDate = formatDate(check.data_inspecao);
            const formattedSearchValue = searchValue.trim();
            return checkDate.includes(formattedSearchValue);
        });

        setNewData(filteredData);
        setPageNumber(1); // Redefinir o número da página para 1 ao filtrar os dados
    };

    const aparelhosAutonomosHome = () => {
        // Defina o número de cards a serem exibidos por página
        const cardsPerPage = 10;
        const startIndex = (pageNumber - 1) * cardsPerPage;
        const endIndex = startIndex + cardsPerPage;
        const currentCards = newData.slice(startIndex, endIndex);

        return (
            <div className="container">
                <h1 className="title-aparelhos">Aparelhos autônomos</h1>
                <div className="container-filters">
                    <div className="search-inputs-container">
                        <div className="search-inputs-container-nr">
                            <SearchInputNR handleSearch={handleSearchNR} />
                        </div>
                        <div className="search-inputs-container-data">
                            <SearchByDate handleSearch={handleSearchDate} />
                        </div>
                    </div>
                </div>
                <div className="pagination-buttons">
                    <button
                        className="pagination-button-1"
                        disabled={pageNumber === 1}
                        onClick={() => setPageNumber(pageNumber - 1)}
                    >
                        <BsFillArrowLeftSquareFill
                            size={30}
                            color="#419A80"
                            style={{ cursor: "pointer" }}
                        />
                    </button>
                    <button
                        className="pagination-button-2"
                        disabled={endIndex >= newData.length}
                        onClick={() => setPageNumber(pageNumber + 1)}
                    >
                        <BsFillArrowRightSquareFill
                            size={30}
                            color="#419A80"
                            style={{ cursor: "pointer" }}
                        />
                    </button>
                </div>
                <div className="content-wrapper">
                    {/* <h3 className="subtitle-aparelhos">Últimas inspeções:</h3> */}
                    <div className="cards-container">
                        {currentCards.map((check, i) => {
                            return (
                                <div className="card" key={i}>
                                    <div className="left-content">
                                        <p>
                                            <strong>Data:</strong>{" "}
                                            {console.log(
                                                formatDate(check.data_inspecao)
                                            )}
                                            {formatDate(check.data_inspecao)}
                                        </p>
                                        <p>
                                            <strong>NR:</strong>{" "}
                                            {check.aparelho.nr_identificacao}
                                        </p>
                                    </div>
                                    <div className="right-content">
                                        <p>
                                            <strong>Vizualizar:</strong>
                                        </p>
                                        <button
                                            onClick={() =>
                                                handleCardClick(check)
                                            }
                                            style={{ cursor: "pointer" }}
                                        >
                                            <BsFillClipboardCheckFill
                                                size={27}
                                                color="#419A80"
                                                background-color="red"
                                                pointer=""
                                            />
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="container">
            <header className="menu-header">
                <MenuHeader></MenuHeader>
            </header>
            <div className="menu-lateral-wrapper">
                <MenuLateral></MenuLateral>
            </div>
            {aparelhosAutonomosHome()}
        </div>
    );
}

export function InspecaoDeFrente({ token }) {
    let config = { headers: { "x-access-token": token } };

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [originalData, setOriginalData] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);

    useEffect(() => {
        async function fetchData() {
            try {
                await Requests.getAllInspFrentTrabalho(config).then((res) => {
                    setData(res);
                    setOriginalData(res);
                });
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, []);

    const handleCardClick = (check) => {
        window.location.href = `/realizados/inspecao/${check.id}`;
    };

    if (isLoading) {
        return (
            <div className="loading">
                <p>Loading...</p>
            </div>
        );
    }

    const validDate = (check) => {
        if (check.dt_inspe === null) return "Sem data de inspeção";
        return check.dt_inspe;
    };

    const handleSearchDate = (searchValue) => {
        // Filtrar os resultados com base na data
        const filteredData = originalData.filter((check) => {
            if (!check?.dt_inspe) return false;

            const checkDate = check.dt_inspe.split(" ").join("");
            const formattedSearchValue = searchValue.trim();
            return checkDate.includes(formattedSearchValue);
        });
        setData(filteredData);
        setPageNumber(1);
    };

    const inspDeFrenteHome = () => {
        const cardsPerPage = 10;
        const startIndex = (pageNumber - 1) * cardsPerPage;
        const endIndex = startIndex + cardsPerPage;
        const currentCards = data.slice(startIndex, endIndex);

        return (
            <div className="container">
                <h1 className="title-frente">Inspeção de frente de trabalho</h1>
                <div className="container-filters">
                    <div className="search-inputs-container">
                        <div className="search-inputs-container-data">
                            <SearchByDate handleSearch={handleSearchDate} />
                        </div>
                    </div>
                </div>
                <div className="pagination-buttons">
                    <button
                        className="pagination-button-1"
                        disabled={pageNumber === 1}
                        onClick={() => setPageNumber(pageNumber - 1)}
                    >
                        <BsFillArrowLeftSquareFill
                            size={30}
                            color="#419A80"
                            style={{ cursor: "pointer" }}
                        />
                    </button>
                    <button
                        className="pagination-button-2"
                        disabled={endIndex >= data.length}
                        onClick={() => setPageNumber(pageNumber + 1)}
                    >
                        <BsFillArrowRightSquareFill
                            size={30}
                            color="#419A80"
                            style={{ cursor: "pointer" }}
                        />
                    </button>
                </div>
                <div className="content-wrapper">
                    {/* <h3 className="subtitle-aparelhos">Últimas inspeções:</h3> */}
                    <div className="cards-container">
                        {currentCards.map((check, i) => {
                            return (
                                <div className="card" key={i}>
                                    <div className="left-content">
                                        <p>
                                            <strong>Data:</strong>{" "}
                                            {validDate(check)}
                                        </p>
                                        <p>
                                            <strong>
                                                Nome do responsavel:
                                            </strong>{" "}
                                            {check.nm_responsavel
                                                ? check.nm_responsavel
                                                : "Não informado"}
                                        </p>
                                    </div>
                                    <div className="right-content">
                                        <p>
                                            <strong>Vizualizar:</strong>
                                        </p>
                                        <button
                                            onClick={() =>
                                                handleCardClick(check)
                                            }
                                            style={{ cursor: "pointer" }}
                                        >
                                            <BsFillClipboardCheckFill
                                                size={27}
                                                color="#419A80"
                                                pointer=""
                                            />
                                        </button>
                                        <hr></hr>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="container">
            <header className="menu-header">
                <MenuHeader></MenuHeader>
            </header>
            <div className="menu-lateral-wrapper">
                <MenuLateral></MenuLateral>
            </div>
            {inspDeFrenteHome()}
        </div>
    );
}

export function AnaliseDeRisco({ token }) {
    let config = { headers: { "x-access-token": token } };

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [originalData, setOriginalData] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);

    useEffect(() => {
        async function fetchData() {
            try {
                await Requests.getAllAnaliseRisco(config).then((res) => {
                    setData(res);
                    setOriginalData(res);
                });
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, []);

    if (isLoading) {
        return (
            <div className="loading">
                <p>Loading...</p>
            </div>
        );
    }

    const handleSearchDate = (searchValue) => {
        // Filtrar os resultados com base na data
        const filteredData = originalData.filter((check) => {
            if (!check?.dt_inspecao) return false;

            const checkDate = check.dt_inspecao.split("/").join("");
            const formattedSearchValue = searchValue.trim();
            return checkDate.includes(formattedSearchValue);
        });
        setData(filteredData);
        setPageNumber(1);
    };

    const analiseDeRiscoHome = () => {
        const cardsPerPage = 10;
        const startIndex = (pageNumber - 1) * cardsPerPage;
        const endIndex = startIndex + cardsPerPage;
        const currentCards = data.slice(startIndex, endIndex);

        return (
            <div className="container">
                <h1 className="title-analise">Análise de risco da atividade</h1>
                <div className="container-filters">
                    <div className="search-inputs-container">
                        <div className="search-inputs-container-data">
                            <SearchByDate handleSearch={handleSearchDate} />
                        </div>
                    </div>
                </div>
                <div className="pagination-buttons">
                    <button
                        className="pagination-button-1"
                        disabled={pageNumber === 1}
                        onClick={() => setPageNumber(pageNumber - 1)}
                    >
                        <BsFillArrowLeftSquareFill
                            size={30}
                            color="#419A80"
                            style={{ cursor: "pointer" }}
                        />
                    </button>
                    <button
                        className="pagination-button-2"
                        disabled={endIndex >= data.length}
                        onClick={() => setPageNumber(pageNumber + 1)}
                    >
                        <BsFillArrowRightSquareFill
                            size={30}
                            color="#419A80"
                            style={{ cursor: "pointer" }}
                        />
                    </button>
                </div>
                <div className="content-wrapper">
                    {/* <h3 className="subtitle-aparelhos">Data das inspeções:</h3> */}
                    <div className="cards-container">
                        {currentCards.map((check, i) => {
                            return (
                                <div className="card" key={i}>
                                    <div className="left-content">
                                        <p>
                                            <strong>Data:</strong>{" "}
                                            {formatDate(check.dt_inspecao)}
                                        </p>
                                        <p>
                                            <strong>Nome da empresa:</strong>{" "}
                                            {check.nm_empresa
                                                ? check.nm_empresa
                                                : "Não informado"}
                                        </p>
                                    </div>
                                    <div className="right-content">
                                        <p>
                                            <strong>Vizualizar:</strong>
                                        </p>
                                        <button
                                            onClick={() =>
                                                handleCardClick(check)
                                            }
                                            style={{ cursor: "pointer" }}
                                        >
                                            <BsFillClipboardCheckFill
                                                size={27}
                                                color="#419A80"
                                                pointer=""
                                            />
                                        </button>
                                        <hr></hr>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    };

    const handleCardClick = (check) => {
        window.location.href = `/realizados/analise/${check.id}`;
    };

    return (
        <div className="container">
            <header className="menu-header">
                <MenuHeader></MenuHeader>
            </header>
            <div className="menu-lateral-wrapper">
                <MenuLateral></MenuLateral>
            </div>

            {analiseDeRiscoHome()}
        </div>
    );
}

export function MascaraDeFuga({ token }) {
    let config = { headers: { "x-access-token": token } };

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [originalData, setOriginalData] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);

    useEffect(() => {
        async function fetchData() {
            try {
                await Requests.getAllMascaraFuga(config).then((res) => {
                    setData(res);
                    setOriginalData(res);
                });
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, []);

    if (isLoading) {
        return (
            <div className="loading">
                <p>Loading...</p>
            </div>
        );
    }

    const handleSearchDate = (searchValue) => {
        // Filtrar os resultados com base na data
        const filteredData = originalData.filter((check) => {
            if (!check?.dt_ultima_inspe) return false;

            const checkDate = formatDate(check.dt_ultima_inspe);
            const formattedSearchValue = searchValue.trim();
            return checkDate.includes(formattedSearchValue);
        });
        setData(filteredData);
        setPageNumber(1);
    };

    const mascaraDeFugaHome = () => {
        const cardsPerPage = 10;
        const startIndex = (pageNumber - 1) * cardsPerPage;
        const endIndex = startIndex + cardsPerPage;
        const currentCards = data.slice(startIndex, endIndex);

        return (
            <div className="container">
                <h1 className="title-mascara">Máscara de fuga</h1>
                <div className="container-filters">
                    <div className="search-inputs-container">
                        <div className="search-inputs-container-data">
                            <SearchByDate handleSearch={handleSearchDate} />
                        </div>
                    </div>
                </div>
                <div className="pagination-buttons">
                    <button
                        className="pagination-button-1"
                        disabled={pageNumber === 1}
                        onClick={() => setPageNumber(pageNumber - 1)}
                    >
                        <BsFillArrowLeftSquareFill
                            size={30}
                            color="#419A80"
                            style={{ cursor: "pointer" }}
                        />
                    </button>
                    <button
                        className="pagination-button-2"
                        disabled={endIndex >= data.length}
                        onClick={() => setPageNumber(pageNumber + 1)}
                    >
                        <BsFillArrowRightSquareFill
                            size={30}
                            color="#419A80"
                            style={{ cursor: "pointer" }}
                        />
                    </button>
                </div>
                <div className="content-wrapper">
                    {/* <h3 className="subtitle-aparelhos">Data das inspeções:</h3> */}
                    <div className="cards-container">
                        {currentCards.map((check, i) => {
                            return (
                                <div className="card" key={i}>
                                    <div className="left-content">
                                        <p>
                                            <strong>Data:</strong>{" "}
                                            {formatDate(check.dt_ultima_inspe)}
                                        </p>
                                        <p>
                                            <strong>Nome da empresa:</strong>{" "}
                                            {check.nm_empresa
                                                ? check.nm_empresa
                                                : "Não informado"}
                                        </p>
                                    </div>
                                    <div className="right-content">
                                        <p>
                                            <strong>Vizualizar:</strong>
                                        </p>
                                        <button
                                            onClick={() =>
                                                handleCardClick(check)
                                            }
                                            style={{ cursor: "pointer" }}
                                        >
                                            <BsFillClipboardCheckFill
                                                size={27}
                                                color="#419A80"
                                                pointer=""
                                            />
                                        </button>
                                        <hr></hr>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    };

    const handleCardClick = (check) => {
        window.location.href = `/realizados/mascara/${check.id}`;
    };

    return (
        <div className="container">
            <header className="menu-header">
                <MenuHeader></MenuHeader>
            </header>
            <div className="menu-lateral-wrapper">
                <MenuLateral></MenuLateral>
            </div>
            {mascaraDeFugaHome()}
        </div>
    );
}

export function Diphoterine({ token }) {
    let config = { headers: { "x-access-token": token } };

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [originalData, setOriginalData] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);

    useEffect(() => {
        async function fetchData() {
            try {
                await Requests.getAllDiphoterineBurnfree(config).then((res) => {
                    setData(res);
                    setOriginalData(res);
                });
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, []);

    if (isLoading) {
        return (
            <div className="loading">
                <p>Loading...</p>
            </div>
        );
    }

    const handleSearchDate = (searchValue) => {
        // Filtrar os resultados com base na data
        const filteredData = originalData.filter((check) => {
            if (!check?.dt_inspecao) return false;

            const checkDate = formatDate(check.dt_inspecao);
            const formattedSearchValue = searchValue.trim();
            return checkDate.includes(formattedSearchValue);
        });
        setData(filteredData);
        setPageNumber(1);
    };

    const diphoHome = () => {
        const cardsPerPage = 10;
        const startIndex = (pageNumber - 1) * cardsPerPage;
        const endIndex = startIndex + cardsPerPage;
        const currentCards = data.slice(startIndex, endIndex);

        return (
            <div className="container">
                <h1 className="title-dipho">Diphoterine e Burnfree</h1>
                <div className="container-filters">
                    <div className="search-inputs-container">
                        <div className="search-inputs-container-data">
                            <SearchByDate handleSearch={handleSearchDate} />
                        </div>
                    </div>
                </div>
                <div className="pagination-buttons">
                    <button
                        className="pagination-button-1"
                        disabled={pageNumber === 1}
                        onClick={() => setPageNumber(pageNumber - 1)}
                    >
                        <BsFillArrowLeftSquareFill
                            size={30}
                            color="#419A80"
                            style={{ cursor: "pointer" }}
                        />
                    </button>
                    <button
                        className="pagination-button-2"
                        disabled={endIndex >= data.length}
                        onClick={() => setPageNumber(pageNumber + 1)}
                    >
                        <BsFillArrowRightSquareFill
                            size={30}
                            color="#419A80"
                            style={{ cursor: "pointer" }}
                        />
                    </button>
                </div>
                <div className="content-wrapper">
                    {/* <h3 className="subtitle-aparelhos">Ultimas inspeções:</h3> */}
                    <div className="cards-container">
                        {currentCards.map((check, i) => {
                            return (
                                <div className="card" key={i}>
                                    <div className="left-content">
                                        <p>
                                            <strong>Data:</strong>{" "}
                                            {formatDate(check.dt_inspecao)}
                                        </p>
                                        <p>
                                            <strong>Área:</strong>{" "}
                                            {check.ds_area
                                                ? check.ds_area
                                                : "Não informado"}
                                        </p>
                                    </div>
                                    <div className="right-content">
                                        <p>
                                            <strong>Vizualizar:</strong>
                                        </p>
                                        <button
                                            onClick={() =>
                                                handleCardClick(check)
                                            }
                                            style={{ cursor: "pointer" }}
                                        >
                                            <BsFillClipboardCheckFill
                                                size={27}
                                                color="#419A80"
                                                pointer=""
                                            />
                                        </button>
                                        <hr></hr>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    };

    const handleCardClick = (check) => {
        window.location.href = `/realizados/diphoterine/${check.id}`;
    };

    return (
        <div className="container">
            <header className="menu-header">
                <MenuHeader></MenuHeader>
            </header>
            <div className="menu-lateral-wrapper">
                <MenuLateral></MenuLateral>
            </div>

            {diphoHome()}
        </div>
    );
}

export function ViaturaDeEmergencia({ token }) {
    let config = { headers: { "x-access-token": token } };

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [originalData, setOriginalData] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    // const [userName, setUserName] = useState({});

    useEffect(() => {
        async function fetchData() {
            try {
                await Requests.getAllViaturaEmergencia(config).then((res) => {
                    setData(res);
                    setOriginalData(res);
                });
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, []);

    // useEffect(() => {
    //     const fetchUserNames = async () => {
    //         try {
    //           const userIds = data
    //             .filter((item) => item.id_usuario)
    //             .map((item) => item.id_usuario);
    //           if (userIds.length > 0) {
    //             console.log("Userids:", userIds);
    //             const response = await getNameById(userIds, config);
    //             const userNames = {};
    //             if (Array.isArray(response)) { // Verifica se response é um array
    //               response.forEach((user) => {
    //                 console.log("user do foreach aqui:", user.nome, user.id)
    //                 userNames[user.id] = user.nome; // Use a propriedade correta para o nome do usuário
    //               });
    //             }
    //             setUserName(userNames);
    //           } else {
    //             setUserName({});
    //           }
    //         } catch (error) {
    //           console.error(error);
    //         }
    //       };

    //     fetchUserNames();
    // }, [data]);

    console.log("userName aquiiii:", data);

    if (isLoading) {
        return (
            <div className="loading">
                <p>Loading...</p>
            </div>
        );
    }

    const handleSearchDate = (searchValue) => {
        // Filtrar os resultados com base na data
        const filteredData = originalData.filter((check) => {
            if (!check?.data) return false;

            const checkDate = formatDate(check.data);
            const formattedSearchValue = searchValue.trim();
            return checkDate.includes(formattedSearchValue);
        });
        setData(filteredData);
        setPageNumber(1);
    };

    // const getNameById = async (ids, config) => {
    //     const response = await Requests.getUserNamesByIds(ids, config);
    //     console.log("response aqui getNameById:", response)
    //     return response;
    // };

    const viaturaHome = () => {
        const cardsPerPage = 10;
        const startIndex = (pageNumber - 1) * cardsPerPage;
        const endIndex = startIndex + cardsPerPage;
        const currentCards = data.slice(startIndex, endIndex);

        return (
            <div className="container">
                <h1 className="title-viatura">Viatura de emergencia</h1>
                <div className="container-filters">
                    <div className="search-inputs-container">
                        <div className="search-inputs-container-data">
                            <SearchByDate handleSearch={handleSearchDate} />
                        </div>
                    </div>
                </div>
                <div className="pagination-buttons">
                    <button
                        className="pagination-button-1"
                        disabled={pageNumber === 1}
                        onClick={() => setPageNumber(pageNumber - 1)}
                    >
                        <BsFillArrowLeftSquareFill
                            size={30}
                            color="#419A80"
                            style={{ cursor: "pointer" }}
                        />
                    </button>
                    <button
                        className="pagination-button-2"
                        disabled={endIndex >= data.length}
                        onClick={() => setPageNumber(pageNumber + 1)}
                    >
                        <BsFillArrowRightSquareFill
                            size={30}
                            color="#419A80"
                            style={{ cursor: "pointer" }}
                        />
                    </button>
                </div>
                <div className="content-wrapper">
                    {/* <h3 className="subtitle-aparelhos">Ultimas inspeções:</h3> */}
                    <div className="cards-container">
                        {currentCards.map((check, i) => {
                            return (
                                <div className="card" key={i}>
                                    <div className="left-content">
                                        <p>
                                            <strong>Data:</strong>{" "}
                                            {formatDate(check.data)}
                                        </p>
                                        {/* <p>
                                                <strong>Usuário:</strong>{" "}
                                                {check.id_usuario}
                                            </p> */}
                                    </div>
                                    <div className="right-content">
                                        <p>
                                            <strong>Vizualizar:</strong>
                                        </p>
                                        <button
                                            onClick={() =>
                                                handleCardClick(check)
                                            }
                                            style={{ cursor: "pointer" }}
                                        >
                                            <BsFillClipboardCheckFill
                                                size={27}
                                                color="#419A80"
                                                pointer=""
                                            />
                                        </button>
                                        <hr></hr>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    };

    const handleCardClick = (check) => {
        window.location.href = `/realizados/viatura/${check.id}`;
    };

    return (
        <div className="container">
            <header className="menu-header">
                <MenuHeader></MenuHeader>
            </header>
            <div className="menu-lateral-wrapper">
                <MenuLateral></MenuLateral>
            </div>

            {viaturaHome()}
        </div>
    );
}

export function Birutas({ token }) {
    let config = { headers: { "x-access-token": token } };

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [originalData, setOriginalData] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);

    useEffect(() => {
        async function fetchData() {
            try {
                await Requests.getAllBirutas(config).then((res) => {
                    setData(res);
                    setOriginalData(res);
                });
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, []);

    if (isLoading) {
        return (
            <div className="loading">
                <p>Loading...</p>
            </div>
        );
    }

    const handleSearchDate = (searchValue) => {
        // Filtrar os resultados com base na data
        const filteredData = originalData.filter((check) => {
            if (!check?.datahora_inspecao) return false;

            const checkDate = formatDate(check.datahora_inspecao);
            const formattedSearchValue = searchValue.trim();
            return checkDate.includes(formattedSearchValue);
        });
        setData(filteredData);
        setPageNumber(1);
    };

    const birutasHome = () => {
        const cardsPerPage = 10;
        const startIndex = (pageNumber - 1) * cardsPerPage;
        const endIndex = startIndex + cardsPerPage;
        const currentCards = data.slice(startIndex, endIndex);

        return (
            <div className="container">
                <h1 className="title-birutas">Birutas</h1>
                <div className="container-filters">
                    <div className="search-inputs-container">
                        <div className="search-inputs-container-data">
                            <SearchByDate handleSearch={handleSearchDate} />
                        </div>
                    </div>
                </div>
                <div className="pagination-buttons">
                    <button
                        className="pagination-button-1"
                        disabled={pageNumber === 1}
                        onClick={() => setPageNumber(pageNumber - 1)}
                    >
                        <BsFillArrowLeftSquareFill
                            size={30}
                            color="#419A80"
                            style={{ cursor: "pointer" }}
                        />
                    </button>
                    <button
                        className="pagination-button-2"
                        disabled={endIndex >= data.length}
                        onClick={() => setPageNumber(pageNumber + 1)}
                    >
                        <BsFillArrowRightSquareFill
                            size={30}
                            color="#419A80"
                            style={{ cursor: "pointer" }}
                        />
                    </button>
                </div>
                <div className="content-wrapper">
                    {/* <h3 className="subtitle-aparelhos">Últimas inspeções:</h3> */}
                    <div className="cards-container">
                        {currentCards.map((check, i) => {
                            return (
                                <div className="card" key={i}>
                                    <div className="left-content">
                                        <p>
                                            <strong>Data:</strong>{" "}
                                            {formatDate(
                                                check.datahora_inspecao
                                            )}
                                        </p>
                                    </div>
                                    <div className="right-content">
                                        <p>
                                            <strong>Vizualizar:</strong>
                                        </p>
                                        <button
                                            onClick={() =>
                                                handleCardClick(check)
                                            }
                                            style={{ cursor: "pointer" }}
                                        >
                                            <BsFillClipboardCheckFill
                                                size={27}
                                                color="#419A80"
                                                pointer=""
                                            />
                                        </button>
                                        <hr></hr>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    };

    const handleCardClick = (check) => {
        window.location.href = `/realizados/birutas/${check.id}`;
    };

    return (
        <div className="container">
            <header className="menu-header">
                <MenuHeader></MenuHeader>
            </header>
            <div className="menu-lateral-wrapper">
                <MenuLateral></MenuLateral>
            </div>
            {birutasHome()}
        </div>
    );
}

export function Rotas({ token }) {
    let config = { headers: { "x-access-token": token } };

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [originalData, setOriginalData] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);

    useEffect(() => {
        async function fetchData() {
            try {
                await Requests.getAllRotas(config).then((res) => {
                    setData(res);
                    setOriginalData(res);
                });
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, []);

    if (isLoading) {
        return (
            <div className="loading">
                <p>Loading...</p>
            </div>
        );
    }

    const handleSearchDate = (searchValue) => {
        // Filtrar os resultados com base na data
        const filteredData = originalData.filter((check) => {
            if (!check?.datahora_fim) return false;

            const checkDate = formatDate(check.datahora_fim);
            const formattedSearchValue = searchValue.trim();
            return checkDate.includes(formattedSearchValue);
        });
        setData(filteredData);
        setPageNumber(1);
    };

    console.log(data);

    const rotasHome = () => {
        const cardsPerPage = 10;
        const startIndex = (pageNumber - 1) * cardsPerPage;
        const endIndex = startIndex + cardsPerPage;
        const currentCards = data.slice(startIndex, endIndex);

        return (
            <div className="container">
                <h1 className="title-rotas">Rotas</h1>
                <div className="container-filters">
                    <div className="search-inputs-container">
                        <div className="search-inputs-container-data">
                            <SearchByDate handleSearch={handleSearchDate} />
                        </div>
                    </div>
                </div>
                <div className="pagination-buttons">
                    <button
                        className="pagination-button-1"
                        disabled={pageNumber === 1}
                        onClick={() => setPageNumber(pageNumber - 1)}
                    >
                        <BsFillArrowLeftSquareFill
                            size={30}
                            color="#419A80"
                            style={{ cursor: "pointer" }}
                        />
                    </button>
                    <button
                        className="pagination-button-2"
                        disabled={endIndex >= data.length}
                        onClick={() => setPageNumber(pageNumber + 1)}
                    >
                        <BsFillArrowRightSquareFill
                            size={30}
                            color="#419A80"
                            style={{ cursor: "pointer" }}
                        />
                    </button>
                </div>
                <div className="content-wrapper">
                    {/* <h3 className="subtitle-aparelhos">Últimas inspeções:</h3> */}
                    <div className="cards-container">
                        {currentCards.map((check, i) => {
                            return (
                                <div className="card" key={i}>
                                    <div className="left-content">
                                        <p>
                                            <strong>Data:</strong> <br></br>{" "}
                                            {formatDate(check.datahora_fim)}
                                        </p>
                                        <p>
                                            <strong>Rota:</strong> {check.nome}
                                        </p>
                                    </div>
                                    <div className="right-content">
                                        <p>
                                            <strong>Vizualizar:</strong>
                                        </p>
                                        <button
                                            onClick={() =>
                                                handleCardClick(check)
                                            }
                                            style={{ cursor: "pointer" }}
                                        >
                                            <BsFillClipboardCheckFill
                                                size={27}
                                                color="#419A80"
                                                pointer=""
                                            />
                                        </button>
                                        <hr></hr>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    };

    const handleCardClick = (check) => {
        window.location.href = `/realizados/rotas/${check.id_agenda}`;
    };

    return (
        <div className="container">
            <header className="menu-header">
                <MenuHeader></MenuHeader>
            </header>
            <div className="menu-lateral-wrapper">
                <MenuLateral></MenuLateral>
            </div>
            {rotasHome()}
        </div>
    );
}

export function Veiculos({ token }) {
    let config = { headers: { "x-access-token": token } };

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [originalData, setOriginalData] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);

    useEffect(() => {
        async function fetchData() {
            try {
                await Requests.getAllVeiculos(config).then((res) => {
                    setData(res);
                    setOriginalData(res);
                });
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, []);

    if (isLoading) {
        return (
            <div className="loading">
                <p>Loading...</p>
            </div>
        );
    }

    const handleSearchDate = (searchValue) => {
        // Filtrar os resultados com base na data
        const filteredData = originalData.filter((check) => {
            if (!check?.data) return false;

            const checkDate = formatDate(check.data);
            const formattedSearchValue = searchValue.trim();
            return checkDate.includes(formattedSearchValue);
        });
        setData(filteredData);
        setPageNumber(1);
    };

    const veiculosHome = () => {
        const cardsPerPage = 10;
        const startIndex = (pageNumber - 1) * cardsPerPage;
        const endIndex = startIndex + cardsPerPage;
        const currentCards = data.slice(startIndex, endIndex);

        return (
            <div className="container">
                <h1 className="title-veiculos">Veículos</h1>
                <div className="container-filters">
                    <div className="search-inputs-container">
                        <div className="search-inputs-container-data">
                            <SearchByDate handleSearch={handleSearchDate} />
                        </div>
                    </div>
                </div>
                <div className="pagination-buttons">
                    <button
                        className="pagination-button-1"
                        disabled={pageNumber === 1}
                        onClick={() => setPageNumber(pageNumber - 1)}
                    >
                        <BsFillArrowLeftSquareFill
                            size={30}
                            color="#419A80"
                            style={{ cursor: "pointer" }}
                        />
                    </button>
                    <button
                        className="pagination-button-2"
                        disabled={endIndex >= data.length}
                        onClick={() => setPageNumber(pageNumber + 1)}
                    >
                        <BsFillArrowRightSquareFill
                            size={30}
                            color="#419A80"
                            style={{ cursor: "pointer" }}
                        />
                    </button>
                </div>
                <div className="content-wrapper">
                    {/* <h3 className="subtitle-aparelhos">Últimas inspeções:</h3> */}
                    <div className="cards-container">
                        {currentCards.map((check, i) => {
                            return (
                                <div className="card" key={i}>
                                    <div className="left-content">
                                        <p>
                                            <strong>Data:</strong> <br></br>{" "}
                                            {formatDate(check.data)}
                                        </p>
                                        <p>
                                            <strong>Carro:</strong> <br></br>{" "}
                                            {check.carroSelecionadoNome
                                                ? check.carroSelecionadoNome
                                                : "Não informado"}
                                        </p>
                                        <p>
                                            <strong>Placa:</strong> <br></br>{" "}
                                            {check.carroSelecionadoPlaca
                                                ? check.carroSelecionadoPlaca
                                                : "Não informado"}
                                        </p>
                                    </div>
                                    <div className="right-content">
                                        <p>
                                            <strong>Vizualizar:</strong>
                                        </p>
                                        <button
                                            onClick={() =>
                                                handleCardClick(check)
                                            }
                                            style={{ cursor: "pointer" }}
                                        >
                                            <BsFillClipboardCheckFill
                                                size={27}
                                                color="#419A80"
                                                pointer=""
                                            />
                                        </button>
                                        <hr></hr>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    };

    const handleCardClick = (check) => {
        window.location.href = `/realizados/veiculos/${check.id}`;
    };

    return (
        <div className="container">
            <header className="menu-header">
                <MenuHeader></MenuHeader>
            </header>
            <div className="menu-lateral-wrapper">
                <MenuLateral></MenuLateral>
            </div>

            {veiculosHome()}
        </div>
    );
}

export function Rtc({ token }) {
    let config = { headers: { "x-access-token": token } };

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [originalData, setOriginalData] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);

    useEffect(() => {
        async function fetchData() {
            try {
                await Requests.getAllRTC(config).then((res) => {
                    setData(res);
                    setOriginalData(res);
                });
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, []);

    if (isLoading) {
        return (
            <div>
                <p>Loading...</p>
            </div>
        );
    }

    const handleSearchDate = (searchValue) => {
        // Filtrar os resultados com base na data
        const filteredData = originalData.filter((check) => {
            if (!check?.data_inspecao) return false;

            const checkDate = formatDate(check.data_inspecao);
            const formattedSearchValue = searchValue.trim();
            return checkDate.includes(formattedSearchValue);
        });
        setData(filteredData);
        setPageNumber(1);
    };

    const rtcHome = () => {
        const cardsPerPage = 10;
        const startIndex = (pageNumber - 1) * cardsPerPage;
        const endIndex = startIndex + cardsPerPage;
        const currentCards = data.slice(startIndex, endIndex);

        return (
            <div className="container">
                <h1 className="title-rtc">Veículos RTC</h1>
                <div className="container-filters">
                    <div className="search-inputs-container">
                        <div className="search-inputs-container-data">
                            <SearchByDate handleSearch={handleSearchDate} />
                        </div>
                    </div>
                </div>
                <div className="pagination-buttons">
                    <button
                        className="pagination-button-1"
                        disabled={pageNumber === 1}
                        onClick={() => setPageNumber(pageNumber - 1)}
                    >
                        <BsFillArrowLeftSquareFill
                            size={30}
                            color="#419A80"
                            style={{ cursor: "pointer" }}
                        />
                    </button>
                    <button
                        className="pagination-button-2"
                        disabled={endIndex >= data.length}
                        onClick={() => setPageNumber(pageNumber + 1)}
                    >
                        <BsFillArrowRightSquareFill
                            size={30}
                            color="#419A80"
                            style={{ cursor: "pointer" }}
                        />
                    </button>
                </div>
                <div className="content-wrapper">
                    {/* <h3 className="subtitle-aparelhos">Últimas inspeções:</h3> */}
                    <div className="cards-container">
                        {currentCards.map((check, i) => {
                            return (
                                <div className="card" key={i}>
                                    <div className="left-content">
                                        <p>
                                            <strong>Data:</strong>{" "}
                                            {check.data_inspecao
                                                ? formatDate(
                                                      check.data_inspecao
                                                  )
                                                : "Não informado"}
                                        </p>
                                        <p>
                                            <strong>Gerencia:</strong>{" "}
                                            {check.gerencia
                                                ? check.gerencia
                                                : "Não informado"}
                                        </p>
                                        <p>
                                            <strong>Área:</strong>{" "}
                                            {check.area
                                                ? check.area
                                                : "Não informado"}
                                        </p>
                                    </div>
                                    <div className="right-content">
                                        <p>
                                            <strong>Vizualizar:</strong>
                                        </p>
                                        <button
                                            onClick={() =>
                                                handleCardClick(check)
                                            }
                                            style={{ cursor: "pointer" }}
                                        >
                                            <BsFillClipboardCheckFill
                                                size={27}
                                                color="#419A80"
                                                pointer=""
                                            />
                                        </button>
                                        <hr></hr>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    };

    const handleCardClick = (check) => {
        window.location.href = `/realizados/rtc/${check.id}`;
    };

    return (
        <div className="container">
            <header className="menu-header">
                <MenuHeader></MenuHeader>
            </header>
            <div className="menu-lateral-wrapper">
                <MenuLateral></MenuLateral>
            </div>

            {rtcHome()}
        </div>
    );
}

export function SalaDaBrigada({ token }) {
    let config = { headers: { "x-access-token": token } };

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [originalData, setOriginalData] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);

    useEffect(() => {
        async function fetchData() {
            try {
                await Requests.getAllSalaBrigada(config).then((res) => {
                    setData(res);
                    setOriginalData(res);
                });
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, []);

    if (isLoading) {
        return (
            <div className="loading">
                <p>Loading...</p>
            </div>
        );
    }

    const handleSearchDate = (searchValue) => {
        // Filtrar os resultados com base na data
        const filteredData = originalData.filter((check) => {
            if (!check?.datahora_inspecao) return false;

            const checkDate = formatDate(check.datahora_inspecao);
            const formattedSearchValue = searchValue.trim();
            return checkDate.includes(formattedSearchValue);
        });
        setData(filteredData);
        setPageNumber(1);
    };

    console.log(data)

    const salaBrigadaHome = () => {
        const cardsPerPage = 10;
        const startIndex = (pageNumber - 1) * cardsPerPage;
        const endIndex = startIndex + cardsPerPage;
        const currentCards = data.slice(startIndex, endIndex);

        return (
            <div className="container">
                <h1 className="title-sala">Sala da Brigada</h1>
                <div className="container-filters">
                    <div className="search-inputs-container">
                        <div className="search-inputs-container-data">
                            <SearchByDate handleSearch={handleSearchDate} />
                        </div>
                    </div>
                </div>
                <div className="pagination-buttons">
                    <button
                        className="pagination-button-1"
                        disabled={pageNumber === 1}
                        onClick={() => setPageNumber(pageNumber - 1)}
                    >
                        <BsFillArrowLeftSquareFill
                            size={30}
                            color="#419A80"
                            style={{ cursor: "pointer" }}
                        />
                    </button>
                    <button
                        className="pagination-button-2"
                        disabled={endIndex >= data.length}
                        onClick={() => setPageNumber(pageNumber + 1)}
                    >
                        <BsFillArrowRightSquareFill
                            size={30}
                            color="#419A80"
                            style={{ cursor: "pointer" }}
                        />
                    </button>
                </div>
                <div className="content-wrapper">
                    {/* <h3 className="subtitle-aparelhos">Últimas inspeções:</h3> */}
                    <div className="cards-container">
                        {currentCards.map((check, i) => {
                            return (
                                <div className="card" key={i}>
                                    <div className="left-content">
                                        <p>
                                            <strong>Data:</strong>{" "}
                                            {formatDate(
                                                check.datahora_inspecao
                                            )}
                                        </p>
                                        {/* <p>
                                            <strong>Usuário:</strong>{" "}
                                            {check.id_usuario
                                                ? check.id_usuario
                                                : "Não informado"}
                                        </p> */}
                                    </div>
                                    <div className="right-content">
                                        <p>
                                            <strong>Vizualizar:</strong>
                                        </p>
                                        <button
                                            onClick={() =>
                                                handleCardClick(check)
                                            }
                                            style={{ cursor: "pointer" }}
                                        >
                                            <BsFillClipboardCheckFill
                                                size={27}
                                                color="#419A80"
                                                pointer=""
                                            />
                                        </button>
                                        <hr></hr>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    };

    const handleCardClick = (check) => {
        window.location.href = `/realizados/sala/${check.id}`;
    };

    return (
        <div className="container">
            <header className="menu-header">
                <MenuHeader></MenuHeader>
            </header>
            <div className="menu-lateral-wrapper">
                <MenuLateral></MenuLateral>
            </div>
            {salaBrigadaHome()}
        </div>
    );
}
